import {
  LAYOUT_COMPONENT_TYPE,
  REGISTRY_BLOCK,
  writeFaqRows,
  type LayoutBlock,
} from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

/** Seed Q&A inspired by common DE food-truck catering FAQs (booking, guests, deposit, weather). */
const FAQ_ITEMS_DE = writeFaqRows([
  {
    question: 'Ab wie vielen Gästen lohnt sich Catering?',
    answer:
      'Ab etwa 30 Gästen — darunter vereinbaren wir einen Mindestumsatz. Ab 50 Personen rechnet es sich in der Regel ohne Extra-Pauschale.',
  },
  {
    question: 'Wie läuft die Buchung ab?',
    answer:
      'Schicken Sie Datum, Ort und Gästezahl — wir prüfen die Verfügbarkeit und senden ein unverbindliches Angebot, meist innerhalb von 24 Stunden.',
  },
  {
    question: 'Was steckt im Preis?',
    answer:
      'Truck, Crew, Ausgabe und Grundausstattung. Anfahrt, längere Standzeit oder Extra-Service stehen transparent im Angebot.',
  },
  {
    question: 'Brauche ich eine Anzahlung?',
    answer:
      'Ja — typisch 30–50 % bei Auftragsbestätigung. Den Rest zahlen Sie vor dem Event oder per Rechnung danach.',
  },
  {
    question: 'Was passiert bei Regen?',
    answer:
      'Der Truck ist wetterfest, braucht aber einen festen, sicheren Stand. Bei starkem Wetter sprechen wir überdachten Aufbau oder einen Alternativtermin ab.',
  },
  {
    question: 'Können Allergene und Sonderwünsche berücksichtigt werden?',
    answer:
      'Ja — schreiben Sie Unverträglichkeiten und Diäten in die Anfrage. Wir stimmen Speisen und Kennzeichnung vor dem Event ab.',
  },
]);

const FAQ_ITEMS_EN = writeFaqRows([
  {
    question: 'From how many guests does catering make sense?',
    answer:
      'From about 30 guests — below that we agree a minimum spend. From 50 people it usually works without an extra surcharge.',
  },
  {
    question: 'How does booking work?',
    answer:
      'Send the date, place, and guest count — we check availability and send a no-obligation quote, usually within 24 hours.',
  },
  {
    question: 'What is included in the price?',
    answer:
      'Truck, crew, service, and basic setup. Travel, longer stand time, or extra service are listed clearly in the quote.',
  },
  {
    question: 'Do I need a deposit?',
    answer:
      'Yes — typically 30–50% when you confirm. You pay the rest before the event or by invoice afterward.',
  },
  {
    question: 'What about rain?',
    answer:
      'The truck is weatherproof but needs a firm, safe pitch. In heavy weather we discuss covered setup or an alternate date.',
  },
  {
    question: 'Can you handle allergies and special diets?',
    answer:
      'Yes — put allergies and diets in the inquiry. We align dishes and labeling before the event.',
  },
]);

export const faqAccordionDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.faq,
  componentType: LAYOUT_COMPONENT_TYPE.faqBlock,
  registryBlockKey: REGISTRY_BLOCK.presentation.faqAccordion,
  displayOrder: 6,
  content: {
    sectionIcon: loc3('MessageCircle', 'MessageCircle', 'MessageCircle'),
    sectionTitle: loc3('Häufige Fragen', 'FAQ', 'Câu hỏi thường gặp'),
    intro: loc3(
      'Kurzantworten zu Buchung, Gästezahl und Ablauf — für Events und Firmenfeiern mit dem Foodtruck.',
      'Short answers on booking, guest count, and how the day runs — for events and company parties with the food truck.',
      'Câu trả lời ngắn về đặt chỗ, số khách và quy trình — cho sự kiện và tiệc công ty với food truck.',
    ),
    faqItems: loc3(FAQ_ITEMS_DE, FAQ_ITEMS_EN, FAQ_ITEMS_EN),
  },
  media: {},
};

export const faqLedgerDefault: LayoutBlock = {
  ...faqAccordionDefault,
  blockId: FIXTURE_BLOCK_IDS.faqLedger,
  registryBlockKey: REGISTRY_BLOCK.presentation.faqLedger,
  displayOrder: 7,
};
